htmx.onLoad(function(elt){
    $localLayout = localStorage.getItem('layout');
    $layoutMeta = document.querySelector('[name="layout"]').content
    $pathName = window.location.pathname
    $search = window.location.search

    // console.log($pathName, $search, $layoutMeta, $localLayout)

    window.isWebview = /webview|wv|ip((?!.*Safari)|(?=.*like Safari))/i.test(window.navigator.userAgent)

    // redirect to app cart if layout app exist
    if(window.isWebview && $localLayout == 'app') {
        if($pathName.includes('/cart') && !$search.includes('view=app')) {
            window.location.href = window.location.href + '?view=app'
        } else if($pathName == '/') {
            window.location.href = window.location.href + '?view=app'
        }
    }

})

htmx.defineExtension('no-title', {

    transformResponse : function(text, xhr, elt) {
        responseTextArr1 = text.split('<title>');
        responseTextArr2 = responseTextArr1[1].split('</title>');
        newText = responseTextArr1[0] + '<title>' + document.title  + '</title>' + responseTextArr2[1]
        return newText;
    }
});

// lazy load sections
htmx.defineExtension('shopify', {
    transformResponse: function (text, xhr, elt) {
        json = JSON.parse(xhr.response);
        jsonId = xhr._url.split("=")[1];
        htmlString = json[jsonId];
        return htmlString;
    }
});

htmx.defineExtension('nohead', {
    transformResponse: function (text, xhr, elt) {
        htmx.on("htmx:beforeHeadMerge", function (evt) {
            if(evt.detail.xhr._url == '/cart/add') {
                console.log('cart event');
                evt.preventDefault()
            }
        })
        return text
    }
})
htmx.defineExtension('minicart', {

    transformResponse: function (text, xhr, elt) {
        window.dispatchEvent(new CustomEvent('minicartv2'))
        return text
    }
})


// ADD TO CART PDP

htmx.defineExtension('add-to-cart', {
    
    onEvent: function (name, evt) {
        if (name === "htmx:configRequest") {
            evt.detail.headers['Content-Type'] = "application/json";
        }
    },
    
    encodeParameters : function(xhr, parameters, elt) {

        function buildjson(objectForm) {

            let response = {
                items: [],
                sections: "layout_header_v2,layout_minicart_v2"
            }
            
            for (const key in objectForm) {

                if (key.includes('items')) {

                    var itemKeys = key.replaceAll('[', '.').replaceAll(']', '.').split('.');

                    if (response.items[itemKeys[1]] == null) {
                        var itemIndex = undefined || {};
                        response.items[itemKeys[1]] = itemIndex; // faltante si ya esta creado no volver a crealo
                    }

                    if (itemKeys[2] == 'id') {
                        response.items[itemKeys[1]].id = objectForm[key];
                    }

                    if (itemKeys[2] == 'quantity') {
                        response.items[itemKeys[1]].quantity = objectForm[key];
                    }

                    if (itemKeys[2] == 'selling_plan') {
                        response.items[itemKeys[1]].selling_plan = objectForm[key];
                    }

                    if (itemKeys[2] == 'properties') {
                        var propertyName = itemKeys[3];

                        if (response['items'][itemKeys[1]]['properties'] == null) {
                            response['items'][itemKeys[1]]['properties'] = undefined || {};
                        }

                        response['items'][itemKeys[1]]['properties'][propertyName] = objectForm[key];
                    }
                } else {

                    
                    if (response.items[0] == null) {
                        var itemIndex = undefined || {};
                        response.items[0] = itemIndex; // faltante si ya esta creado no volver a crealo
                    }
                    
                    if (key == 'id') {
                        response.items[0]['id'] = objectForm[key];
                    }
                    if (key == 'quantity') {
                        response.items[0]['quantity'] = objectForm[key];
                    }
                    if (key == 'selling_plan') {
                        response.items[0]['selling_plan'] = objectForm[key];
                    }
                    if (key.includes('properties')) {
                        response.items[0][key] = objectForm[key];
                    }
                    
                }

            }


            return response;

        }
        
        xhr.overrideMimeType('text/json');
        console.log(parameters)
        return (JSON.stringify(buildjson(parameters)));
    },



    transformResponse: function (text, xhr, elt) {

        response = JSON.parse(text);
        payment = elt.dataset.payment

        // console.log(JSON.parse(new DOMParser().parseFromString(response.sections['cart__table-web'], "text/html").querySelector('#shopify-section-cart__table-web').innerHTML))


        document.querySelector('#cart_total-items').innerHTML = new DOMParser().parseFromString(response.sections.layout_header_v2, "text/html").querySelector('#cart_total-items').innerHTML
        if(document.querySelector('#shopify-section-layout_minicart_v2 #minicart-v2_header') != null) {

            document.querySelector('#shopify-section-layout_minicart_v2 #minicart-v2_header').innerHTML = new DOMParser().parseFromString(response.sections.layout_minicart_v2, "text/html").querySelector('#shopify-section-layout_minicart_v2 #minicart-v2_header').innerHTML
            document.querySelector('#shopify-section-layout_minicart_v2 #minicart-v2_table').innerHTML = new DOMParser().parseFromString(response.sections.layout_minicart_v2, "text/html").querySelector('#shopify-section-layout_minicart_v2 #minicart-v2_table').innerHTML
            
            htmx.process(document.querySelector('#shopify-section-layout_minicart_v2'));
        }

        if (payment == "shoppay") {
          window.location.replace("/checkout?payment=shop_pay");
        } else if (payment == "prgsupplies") {
          window.dispatchEvent(
            new CustomEvent("mbuv4", { detail: {
                sku: "RGM-PRG-ANNUAL-B4",
                action: "open"
            }
            })
          );
        } else {
          window.dispatchEvent(new CustomEvent("minicartv2"));
          window.dispatchEvent(new CustomEvent("getcart"));
          window.dispatchEvent(new CustomEvent("opencart"));
        }
        
        return text;
    }
});

htmx.on("htmx:afterSwap", function (evt) {
    // console.log('%cafterSwap', baseStyles);
    //document.querySelector('#swup').classList.remove('htmx-request')
    let pathUrl = evt.detail.pathInfo.requestPath;
    const targetElement = evt.detail.target.id;
    if (targetElement == 'swup' && window.scrollY > 52) {
        window.scrollTo({
            top: 52,
            behavior: 'instant'
        });
    }

})


window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == "submit") {
    console.log(e)
    gtag('event', 'conversion', {'send_to': 'AW-720003505/ckvfCLjfzNwBELHDqdcC'});
  }
});